//
//
//
//
import drApplyBase from '../drApplyBase';
export default {
  name: 'drPurchase',
  components: {
    drApplyBase: drApplyBase
  }
};